<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div style="display: flex; justify-content: center">
      <mat-button-toggle-group aria-label="Font Style" [(ngModel)]="view">
        <mat-button-toggle value="home" routerLink="/tablero/home"
          >Home</mat-button-toggle
        >
        <mat-button-toggle value="profile" routerLink="/tablero/profile">
          Perfil</mat-button-toggle
        >
        <mat-button-toggle value="varieties" routerLink="/catalogo">
          <span style="text-decoration: underline"> Variedades </span>
        </mat-button-toggle>

        <mat-button-toggle
          value="variety-list-edit"
          *ngIf="fnIsRole('ADMIN')"
          routerLink="/tablero/variety-list-edit"
        >
          Editar variedades</mat-button-toggle
        >
        <mat-button-toggle
          value="import-varieties"
          *ngIf="fnIsRole('ADMIN')"
          routerLink="/tablero/import-varieties"
        >
          Importar variedades</mat-button-toggle
        >
        <mat-button-toggle
          value="observations"
          routerLink="/observaciones"
          style="text-decoration: underline"
        >
          <span style="text-decoration: underline"> Observaciones </span>
        </mat-button-toggle>
        <mat-button-toggle
          value="explorer-list-edit"
          routerLink="/tablero/explorer-list-edit"
        >
          Editar observaciones</mat-button-toggle
        >
        <mat-button-toggle
          value="import-observation"
          *ngIf="fnIsRole('ADMIN')"
          routerLink="/tablero/import-observation"
        >
          Importar observaciones</mat-button-toggle
        >
        <!-- <mat-button-toggle value="favoritos"> Favoritos</mat-button-toggle> -->
      </mat-button-toggle-group>
    </div>

    <div *ngIf="view == 'home'">
      <app-home-view></app-home-view>
    </div>
    <div *ngIf="view == 'profile'">
      <app-user-view></app-user-view>
    </div>
    <div *ngIf="view == 'variety-list-edit'">
      <app-catalogo-list-edit-view></app-catalogo-list-edit-view>
    </div>
    <div *ngIf="view == 'import-varieties'">
      <app-variedad-import></app-variedad-import>
    </div>
    <div *ngIf="view == 'explorer-list-edit'">
      <app-explorer-list-edit-view></app-explorer-list-edit-view>
    </div>
    <div *ngIf="view == 'import-observation'">
      <app-observation-import></app-observation-import>
    </div>
    <!-- <div *ngIf="view == 'favoritos'">
      <app-favorites-view></app-favorites-view>
    </div> -->
  </div>
</div>
